import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {sendEmailSupport as sendEmailSupportAPI} from '../../../services/reservationItem'

export async function emailReservationUpgrade(dispatch) {
  try {
    dispatch({type: PENDING})
    let response = await sendEmailSupportAPI()
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Email Failed`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
